import { motion } from "framer-motion";
import { Link } from "react-router-dom";

function AboutUsItem({ name, profilePic, git, linkedin, bio }) {
  return (
    <div className="mb-3">
      <p className="mt-3 text-center text-dark fs-2">{name}</p>
      <div className="text-center p-3 d-flex flex-column">
        <div className="rounded  text-center pb-3">
          <img
            src={`${profilePic}`}
            className="rounded shadow img-fluid"
            style={{ width: "auto", height: "12rem", objectFit: "cover" }}
            alt="placeholder"
          />
        </div>

        <div className="d-flex justify-content-center mt-3 mb-2">
          <motion.div
            whileHover={{ scale: 1.1 }}
            style={{
              cursor: "pointer",
              width: "fit-content",
            }}
            className="me-4"
          >
            <Link
              to={{ pathname: git }}
              style={{ color: "inherit", textDecoration: "inherit" }}
              target="_blank"
            >
              <i className=" fab fa-github fs-2"></i>{" "}
            </Link>
          </motion.div>
          <motion.div
            whileHover={{ scale: 1.1 }}
            style={{
              cursor: "pointer",
              width: "fit-content",
            }}
            className="ms-4"
          >
            <Link to={{ pathname: linkedin }} target="_blank">
              <i className=" fab fa-linkedin-in fs-2" style={{ color: "#0a66c2" }}></i>
            </Link>
          </motion.div>
        </div>
        <p>{bio}</p>
      </div>
    </div>
  );
}

export default AboutUsItem;
